import { Component, OnInit, ViewEncapsulation, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { FileManagerService } from './file-manager.service';
import { fuseAnimations } from '../../../core/animations';
import { Fichero } from '../../../core/modelos/fichero';
import { NewFolderService } from '../../../core/new-folder/new-folder.service';
import { Cliente } from '../../../core/modelos/cliente';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { User } from '../../../core/modelos/user';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ClientesComponent } from '../clientes/clientes.component';
import { Subscription } from 'rxjs/Subscription';
import { ActivosService } from '../activos/activos.service';
import { ConfirmService } from '../../../core/components/confirm/confirm.service';

@Component({
    selector: 'fuse-file-manager',
    templateUrl: './file-manager.component.html',
    styleUrls: ['./file-manager.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class FileManagerComponent implements OnInit, OnDestroy {

    selected: any;
    pathArr: string[];
    rutaActual = '';
    ficheros = new Array<Fichero>();
    clientes: Array<Cliente>;
    clienteSeleccionado: Cliente;

    selectedFiles: FileList;
    busqueda;

    usuarioLogueado: User;

    navigationSubscription: Subscription;

    projectRoot;

    esRaiz: boolean;
    buscando: boolean;
    busquedaSuscription: Subscription;

    idActivo: number;

    @ViewChild('fileInput')
    fileInput: ElementRef;

    constructor(
        private fileManagerService: FileManagerService,
        private newFolderService: NewFolderService,
        private notificaciones: NotificacionesService,
        private router: Router,
        private activosService: ActivosService,
        private activatedRoute: ActivatedRoute,
        private confirmService: ConfirmService
    ) {
        // this.init();
        this.activatedRoute.params.subscribe(params => {
            switch (params.accion) {
                case 'raiz': this.esRaiz = true;
                    break;

                case 'buscar': this.buscando = true;
                    break;
            }

            // Parsear el idActivo
            if (Number.isInteger(parseInt(params.accion))) {
                this.idActivo = parseInt(params.accion)
                this.getActivo()
            }

            // notify about the new activo (it could be null)
            this.activosService.setCurrentActivo(this.idActivo)
        });

        this.navigationSubscription = this.router.events.subscribe((e: any) => {
            // If it is a NavigationEnd event re-initalise the component
            if (e instanceof NavigationEnd) {
                this.initialiseInvites();
            }
        });
    }

    ngOnInit() {
        /* if (this.usuarioLogueado.rol.id === 1) {
            this.getClientes();
        } */
    }

    initialiseInvites() {
        this.init();
    }

    init() {

        this.usuarioLogueado = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
        this.fileManagerService.carpetaActual = null;
        this.clienteSeleccionado = this.usuarioLogueado.cliente;

        this.fileManagerService.onFileSelected.subscribe(selected => {
            this.selected = selected;
        });

        this.fileManagerService.getRutaActual().subscribe(
            ruta => {
                if (typeof ruta === 'string') {
                    this.rutaActual = ruta;
                    // Formo el array para el botón Project Root
                    this.projectRoot = ruta.split('/').length > 1 ? ruta.split('/') : null;

                } else {
                    this.goHome();
                }

                // Hacemos scroll arriba al cambiar de carpeta para asegurarnos de que el usuario siempre vea su contenido.
                document.getElementById('file-manager').scrollTop = 0;
            }
        );

        if (this.esRaiz) {
            this.buscando = false;
            this.actualizarFicheros();
        } else if (this.buscando) {
            this.buscarDoc();
        } else {
            this.buscando = false;
            this.buscarCarpeta();
        }
    }

    getActivo() {
      this.activosService.getActivo(this.idActivo).subscribe(
          data => {
              if (data.success) {
                  if (data.items.carpetaAWS) {
                    this.fileManagerService.setCarpetaDestino(data.items.carpetaAWS);
                  }
              } else {
                  // CONTROLAR ERROR
                  this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoNOObtenido);
              }
          },
          err => {
              // CONTROLAR ERROR
              this.notificaciones.errorServidor(err.status);
          }
      );
    }

    buscarDoc() {
        this.busquedaSuscription = this.fileManagerService.getFicheroDashboard().subscribe(
            fichero => {
                // Metodo para sacar por pantalla solo el archivo que el usuario eligio en del Dashboard

                /* this.busqueda = fichero.name;
                const buscar = fichero.name; */

                /* Se cambia la búsqueda por la ruta completa del archivo, cuando se pase */

                this.busqueda = fichero.key;
                const buscar = fichero.key;

                setTimeout(() => {
                    // Le pongo un timeout porque, para hacer la busqueda, primero debe cargar los ficheros
                    this.buscarArchivo(buscar);
                }, 500);
            }
        );
    }

    buscarCarpeta() {
        // Subscripcion para a ir la carpeta de un proyecto
        this.fileManagerService.getCarpetaDestino().subscribe(
            carpeta => {
                this.fileManagerService.carpetaActual = carpeta;
            }
        );
        this.actualizarFicheros();
    }

    ngOnDestroy() {
        // avoid memory leaks here by cleaning up after ourselves. If we
        // don't then we will continue to run our initialiseInvites()
        // method on every navigationEnd event.
        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
        if (this.busquedaSuscription) {
            this.busquedaSuscription.unsubscribe();
        }
    }

    goHome() {
        this.fileManagerService.carpetaActual = null;
        this.actualizarFicheros();
    }

    goHome2() {
        this.fileManagerService.carpetaActual = this.projectRoot[0];
        this.actualizarFicheros();
    }

    setCliente(cliente: Cliente) {
        this.fileManagerService.setClienteBucket(cliente);
        ClientesComponent.cambiarCliente(cliente);
        this.fileManagerService.carpetaActual = null;
        this.actualizarFicheros();
    }

    selectFile(event) {

        this.selectedFiles = event.target.files;

        const file = this.selectedFiles.item(0);

        this.fileManagerService.headObject(file).send((err) => {

            if (err) {
                this.upload(file);
            }
            else {

                this.confirmService.confirm(this.notificaciones.mensajes.IdiomaActual.FileManager.SubirArchivoExistente.Titulo,
                    this.notificaciones.mensajes.IdiomaActual.FileManager.SubirArchivoExistente.Mensaje).subscribe(result => {

                        if (result) {
                            this.upload(file);
                        }
                        else {
                            this.clearFileInput();
                        }
                    });
            }
        });
    }

    upload(file) {

        this.fileManagerService.uploadfile(file).send((err) => {

                if (!err) {
                    this.actualizarFicheros();
                }

                this.clearFileInput();
            });
    }

    clearFileInput() {

        this.fileInput.nativeElement.value = '';
    }

    newFolder() {
        /* if (this.usuarioLogueado.rol.id === 1 && !this.clienteSeleccionado) {
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.ClienteNoEstablecido);
        }
        else { */
            this.newFolderService.openModal().subscribe(
                nombre => {
                    if (nombre) {
                        const partes = nombre.split('/');
                        if (partes.length > 1) {
                            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.NombreIncorrecto);
                        }
                        else {
                            const component = this;
                            this.fileManagerService.newFolder(nombre).send(function (err) {
                                if (!err) {
                                    component.actualizarFicheros();
                                }
                            });
                        }
                    }
                }
            );
        // }
    }
    buscarArchivo(busqueda: any) {
        /* if (this.usuarioLogueado.rol.id === 1 && !this.clienteSeleccionado) {
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.ClienteNoEstablecido);
        }
        else */ if (!busqueda) {
            this.actualizarFicheros();
        }
        else {
            const component = this;
            this.fileManagerService.getAllFiles().send(function (err, data) {
                if (!err) {

                    const ficheros = [];

                    const ficherosCategorizados = FileManagerService.categorizarFicheros(data);
                    // component.fileManagerService.carpetaActual = null;
                    ficherosCategorizados.forEach(fichero => {

                        const rutaLenght = component.rutaActual.length + 1;
                        const carpetaFichero = fichero.name.substr(0, rutaLenght);
                        const ruta = component.rutaActual + '/';

                        if (component.rutaActual) {
                            if (carpetaFichero === ruta) {
                                if (fichero.name.toUpperCase().includes(busqueda.toUpperCase())) {
                                    component.fileManagerService.carpetaActual = fichero.key;
                                    ficheros.push(fichero);
                                }
                            }
                        } else {
                            if (fichero.name.toUpperCase().includes(busqueda.toUpperCase())) {
                                component.fileManagerService.carpetaActual = fichero.key;
                                ficheros.push(fichero);
                            }
                        }

                        /* if (fichero.name.toUpperCase().includes(busqueda.toUpperCase())) {
                            ficheros.push(fichero);
                        } */
                    });

                    // data.Contents.forEach(fichero => {
                    //     if (fichero.Key.toUpperCase().includes(component.busqueda.toUpperCase())) {
                    //         ficheros.push(fichero);
                    //     }
                    // });

                    // data.Contents = ficheros;
                    if (ficheros.length > 0) {
                        // Los manda a un observable que es recogido en este componente y genera la rama apropiada del arbol
                        component.fileManagerService.actualizarFicheros(ficheros);
                    }
                    else {
                        component.notificaciones.mostrarAviso(component.notificaciones.mensajes.IdiomaActual.FileManager.BusquedaSinResultados);
                    }
                }
                component.busqueda = null;
            });
        }
    }
    actualizarFicheros() {
        /* if (this.usuarioLogueado.rol.id === 1 && !this.clienteSeleccionado) {
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.ClienteNoEstablecido);
        } */
        // else {
            const component = this;
            this.fileManagerService.actualizarFicheros([]);
            this.fileManagerService.getFiles().send(function (err, data) {
                if (!err) {
                    const ficheros = FileManagerService.categorizarFicheros(data);
                    component.fileManagerService.actualizarFicheros(ficheros);
                }
            });
        // }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/file-manager/file-manager.component.ts